import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
//PC代理业绩&H5今日收益类
export var Performance = /*#__PURE__*/_createClass(function Performance() {
  _classCallCheck(this, Performance);
});
//管理推广码
//PC&&H5端->分红记录
_defineProperty(Performance, "getSummaryRecord", "/api/proxy/center/getSummaryRecord");
//PC&&H5->代理业绩
_defineProperty(Performance, "proxyPerformance", "/api/proxy/center/proxyPerformance");
//PC&&H5端->游戏大类搜索下拉框数据
_defineProperty(Performance, "getLiveGames", "/api/proxy/center/getLiveGames");
//PC端获取代理佣金和下级人数
_defineProperty(Performance, "getStatisData", "/api/proxy/center/getStatisData");
//PC端获取充值top排名
_defineProperty(Performance, "getRechargeLimit", "/api/proxy/center/getRechargeLimit");
//PC端获取打码top排名
_defineProperty(Performance, "getValidAmountLimit", "/api/proxy/center/getValidAmountLimit");
export var SpreadCodeManager = /*#__PURE__*/_createClass(function SpreadCodeManager() {
  _classCallCheck(this, SpreadCodeManager);
});
//下级列表
//获取代理推广链接列表
_defineProperty(SpreadCodeManager, "getSummaryRecord", "/api/proxy/center/getSpreadLink");
//获取推广链接客户端类型集
_defineProperty(SpreadCodeManager, "spreadTypeList", "/api/proxy/center/spreadTypeList");
//删除代理推广链接
_defineProperty(SpreadCodeManager, "deleteLink", "/api/proxy/center/deleteLink");
//查看推广链接预设分红配置
_defineProperty(SpreadCodeManager, "getLinkDivideConfig", "/api/proxy/center/getLinkDivideConfig");
//代理根据某个推广链接新增下级
_defineProperty(SpreadCodeManager, "saveUserByLink", "/api/proxy/center/saveUserByLink");
//新增推广码前获取彩票投注返点下拉框数据
_defineProperty(SpreadCodeManager, "getLotteryRateOptions", "/api/proxy/center/getLotteryRateOptions");
//新增推广码获取分红配置基础数据
_defineProperty(SpreadCodeManager, "getEnableDivide", "/api/proxy/center/getEnableDivide");
//代理新增推广码
_defineProperty(SpreadCodeManager, "saveSpreadLinkCode", "/api/proxy/center/saveSpreadLinkCode");
export var LlevelList = /*#__PURE__*/_createClass(function LlevelList() {
  _classCallCheck(this, LlevelList);
});
//游戏记录
//获取代理下级列表
_defineProperty(LlevelList, "getProxyTeamList", "/api/proxy/center/getProxyTeamList");
//新增下级前获取彩票投注返点下拉框数据
//SpreadCodeManager.getLotteryRateOptions
//新增下级前获取分红配置基础数据
_defineProperty(LlevelList, "getEnableDivide", "/api/proxy/center/getEnableDivide");
//代理新增直接下级(邀请码开户或分红配置开户)
_defineProperty(LlevelList, "saveUser", "/api/proxy/center/saveUser");
//编辑用户时获取彩票投注返点下拉框数据
_defineProperty(LlevelList, "getRebateForEdit", "/api/proxy/center/getRebateForEdit");
//编辑下级分红前获取分红基础数据
_defineProperty(LlevelList, "getEnableDivideEdit", "/api/proxy/center/getEnableDivideEdit");
//代理列表编辑分红配置
_defineProperty(LlevelList, "editChildDivide", "/api/proxy/center/editChildDivide");
//获取团队余额
_defineProperty(LlevelList, "getTeamAmount", "/api/proxy/center/getTeamAmount");
export var gameRecord = /*#__PURE__*/_createClass(function gameRecord() {
  _classCallCheck(this, gameRecord);
});
//团队统计
//PC&&H5端->游戏大类搜索下拉框数据
_defineProperty(gameRecord, "getTeamBill", "/api/proxy/center/getLiveGames");
//H5端游戏记录汇总
_defineProperty(gameRecord, "getGameReportStatis", "/api/proxy/center/getGameReportStatis");
//PC&H5代理获取下级的游戏投注记录
_defineProperty(gameRecord, "getBetRecords", "/api/proxy/center/getBetRecords");
export var teamStatistics = /*#__PURE__*/_createClass(function teamStatistics() {
  _classCallCheck(this, teamStatistics);
});
//团队统计
//下级财务报表
_defineProperty(teamStatistics, "getTeamBill", "/api-auth/api/open/user-server/oauth/pt/player/proxy/getTeamStatis.json");
//下级投注报表
_defineProperty(teamStatistics, "getGameReportStatis", "/api-auth/api/open/user-server/oauth/pt/player/proxy/getTeamBetReport.json");
export var Llevelfinance = /*#__PURE__*/_createClass(function Llevelfinance() {
  _classCallCheck(this, Llevelfinance);
});
//用户信息
//充值日志
_defineProperty(Llevelfinance, "getProxyRechargeRecord", "/api/proxy/center/getProxyRechargeRecord");
//首充明细
_defineProperty(Llevelfinance, "getGameReportStatis", "/api/proxy/center/getProxyFirstRecharge");
//提现日志
_defineProperty(Llevelfinance, "getProxyWithDrawRecord", "/api/proxy/center/getProxyWithDrawRecord");
//额度转换记录
_defineProperty(Llevelfinance, "getProxyGameTransferRecord", "/api-auth/api/open/user-server/oauth/pt/player/proxy/getProxyGameTransferRecord.json");
//其它记录
_defineProperty(Llevelfinance, "getProxyOtherFinancial", "/api-auth/api/open/user-server/oauth/pt/player/proxy/getProxyOtherFinancial.json");
//存款
_defineProperty(Llevelfinance, "getProxyOthgetProxyRechargeRecorderFinancial", "/api/proxy/center/getProxyRechargeRecord");
//首充
_defineProperty(Llevelfinance, "getProxyFirstRecharge", "/api/proxy/center/getProxyFirstRecharge");
export var AgentAuth = /*#__PURE__*/_createClass(function AgentAuth() {
  _classCallCheck(this, AgentAuth);
});
//首页信息
//登录
_defineProperty(AgentAuth, "login", "/api/agent/auth/login");
//登出
_defineProperty(AgentAuth, "logout", "/api/agent/auth/logout");
//用户信息
_defineProperty(AgentAuth, "agUserInfo", "/api/agent/member/info");
export var AgentHome = /*#__PURE__*/_createClass(function AgentHome() {
  _classCallCheck(this, AgentHome);
});
// 代理推广详情
//首页统计信息
_defineProperty(AgentHome, "statistics", "/api/agent/home/statistics");
_defineProperty(AgentHome, "list", "/api/agent/home/detailPage");
// 首页 banner
_defineProperty(AgentHome, "banner", "/api/agent/system/banner/pageList");
// 首页公告消息 notice
_defineProperty(AgentHome, "notice", "/api/agent/message/pageList");
// 首页红利详情
_defineProperty(AgentHome, "bonusDetail", "/api/agent/home/detailBonusAmount");
// 总输赢详情
_defineProperty(AgentHome, "totalWinDetail", "/api/agent/same-level/report/gameWinPage");
// 首页活跃用户详情
_defineProperty(AgentHome, "activeMember", "/api/agent/member/activeMemberPage");
// 获取当前用户分享链接
_defineProperty(AgentHome, "shareLink", "/api/link/config/spread/getLinkForLower");
export var AgentPromotion = /*#__PURE__*/_createClass(function AgentPromotion() {
  _classCallCheck(this, AgentPromotion);
});
// 下级管理
// 推广代理列表
_defineProperty(AgentPromotion, "list", "/api/agent/report/list");
// 推广代理子级详情
_defineProperty(AgentPromotion, "agentTeamList", "/api/agent/report/agentTeamList");
export var LlevelManger = /*#__PURE__*/_createClass(function LlevelManger() {
  _classCallCheck(this, LlevelManger);
});
//充值提现相关
//团队成员
_defineProperty(LlevelManger, "pageList", "/api/agent/member/teamMemberPage");
//会员详情
_defineProperty(LlevelManger, "getMemberDetail", "/api/agent/member/getMemberDetail");
//游戏记录
_defineProperty(LlevelManger, "betRecord", "/api/agent/game/queryGameBetRecordPage");
//场馆下拉选项
_defineProperty(LlevelManger, "gameType", "/api/agent/game/selectGameKindList");
//存款记录
_defineProperty(LlevelManger, "rPageList", "/api/agent/finance/rechargeOrderHistory/page");
//红利记录
_defineProperty(LlevelManger, "BonusRcds", "/api/agent/member/queryBonusPage");
//代理报表
_defineProperty(LlevelManger, "agentReport", "/api/agent/member/queryAgentPage");
//新增 溢出申请
_defineProperty(LlevelManger, "addSpillApply", "/api/agent/member/agentChange/addAgentChange");
//溢出申请列表
_defineProperty(LlevelManger, "spillApplyList", "/api/agent/member/agentChange/pageList");
// 修改会员备注接口
_defineProperty(LlevelManger, "editRemark", "/api/agent/member/remark/edit");
// 查询会员游戏余额
_defineProperty(LlevelManger, "gameBalance", "/api/agent/game1/selectGameBalanceByAccount");
// 推荐奖励列表
_defineProperty(LlevelManger, "inviteRewardList", "/api/proxy/divideInviteReward/list");
// 邀请统计
_defineProperty(LlevelManger, "findInviteReward", "/api/proxy/divideInviteReward/findInviteReward");
_defineProperty(LlevelManger, "findBonusRecord", "/api/agent/home/findBonusRecord");
export var AFinance = /*#__PURE__*/_createClass(function AFinance() {
  _classCallCheck(this, AFinance);
});
//推广部分（配置）
//充值订单
_defineProperty(AFinance, "rcgList", "/api/agent/finance/rechargeOrderHistory/page");
//提现订单
_defineProperty(AFinance, "wdwList", "/api/agent/finance/memberWithdrawHistory/page");
//佣金报表 (A commission report)
_defineProperty(AFinance, "acrList", "/api/agent/same-level/report/sameData");
_defineProperty(AFinance, "rcgTypeList", "/api/agent/recharge/order/disaccount/types");
// 货币下拉列表
_defineProperty(AFinance, "walletList", "/api/agent/finance/wallet/wallet_list");
// mango奖金
_defineProperty(AFinance, "getCommissionRecord", "/api/agent/commission/getCommissionRecord");
export var Spread = /*#__PURE__*/_createClass(function Spread() {
  _classCallCheck(this, Spread);
});
// 代理系统配置
//推广链接
_defineProperty(Spread, "linkList", "/api/agent/spread/link/page");
//新增推广前 获取彩票投注返点数据
_defineProperty(Spread, "lotteryRebates", "/api/agent/member/getRebateOptionsForAdd");
//新增推广前 获取推广类型列表
_defineProperty(Spread, "promotType", "/api/agent/spread/link/spreadTypeList");
//新增邀请码链接
_defineProperty(Spread, "addInviteCode", "/api/agent/spread/link/add");
// 推广配置
_defineProperty(Spread, "inviteCodeConfig", "/api/agent/spread/link/config");
_defineProperty(Spread, "inviteCodeDelete", "/api/agent/spread/link/remove");
// 获取推广域名
_defineProperty(Spread, "promoteDomainList", "/api/agent/spread/link/getDefaultLink");
// mango邀请和奖励地址
_defineProperty(Spread, "getSpreadLink", "/api/agent/commission/getSpreadLink");
// mango邀请数据和配置
_defineProperty(Spread, "getReport", "/api/agent/commission/getReport");
export var SystemConfig = /*#__PURE__*/_createClass(function SystemConfig() {
  _classCallCheck(this, SystemConfig);
});
// 语言列表
_defineProperty(SystemConfig, "langList", "/api/agent/finance/wallet/language_list");
export var MangoAgent = /*#__PURE__*/_createClass(function MangoAgent() {
  _classCallCheck(this, MangoAgent);
});
// 获取邀请链接
_defineProperty(MangoAgent, "getSpreadLink", "/api/commission/getSpreadLink");
// 获取即时报表和邀请配置
_defineProperty(MangoAgent, "getReport", "/api/commission/getReport");
// 获取已付佣金
_defineProperty(MangoAgent, "getPayCommission", "/api/commission/getPayCommission");
// 获取下线统计报表
_defineProperty(MangoAgent, "getLowerStatis", "/api/commission/getLowerStatis");
// 薪水 工资记录
_defineProperty(MangoAgent, "getSalary", "/api/commission/getSalary");
// 受邀人 下线用户报表
_defineProperty(MangoAgent, "getInviteRecord", "/api/commission/getInviteRecord");
// 奖金 个人奖金列表
_defineProperty(MangoAgent, "getCommissionRecord", "/api/commission/getCommissionRecord");